module.exports = __webpack_public_path__ + "pstatic/media/new_message.90537734.mp3";